import { useState } from 'react';

export const useHomeLoanFieldState = initialValue => {
  const [val, setVal] = useState(initialValue);
  const [isOpen, setIsOpen] = useState(false);

  return [val, setVal, isOpen, setIsOpen];
};

export const optionsForLoanType = [
  { value: 'MORTGAGE_30Y', label: '30 Year Fixed' },
  { value: 'MORTGAGE_15Y', label: '15 Year Fixed' },
  { value: 'MORTGAGE_10Y', label: '10 Year Fixed' },
];

export const buildHomeLoanQueryObject = (queryAttributes, loanCategory) => {
  let basicQuery = {
    userId: 'me',
    loanType: loanCategory,
    loanAmount: queryAttributes.loanAmount,
    mortgageProductCode: queryAttributes.loanType,
    rateSource: 'EXTERNAL',
    itemsPerPage: 20,
  };

  return { ...basicQuery };
};
